
























































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import BookmarkAdd from '@/components/bookmark/bookmark-add.vue';
import MainMenuMobile from '@/views/layout/navigation/main-menu-mobile.vue';
import ReportTabsMixin from '@/views/reports/views/mixins/report-tabs-mixin';
import MainMenuReportTabsMobileItem from '@/views/layout/navigation/grouping/main-menu-report-tabs-mobile-item.vue';
import BookmarkAddMenu from '@/components/bookmark/bookmark-add-menu.vue';
import ReportTabsActions from '@/views/reports/views/report-tabs-actions.vue';

@Component({
  components: {
    BookmarkAdd,
    MainMenuMobile,
    MainMenuReportTabsMobileItem,
    BookmarkAddMenu,
    ReportTabsActions,
  }
})
export default class ReportTabs extends mixins(UrlMixin, ReportTabsMixin) {
  get isComplexTabs() {
    return this.commonTabsLength > 1 && (this.isManyReports || this.isOverflowing || this.forceShowGroupingTabs);
  }

  get isGroupingActive() {
    return this.currentTab && (this.currentTab.tabId === this.$store.state.table.activeTab || this.isSettingsRoute);
  }

  get menuContentClass() {
    let result: string[] = [ 'hidden-sm-and-down', 'report-tabs__group-menu' ];

    if(!this.isGroupingActive) {
      result.push('report-tabs__group-menu--not-active');
    }

    return result.join(' ');
  }
  menuOpened: {[type: number]: boolean} = {};

  handleMenu(index: number) {
    this.menuOpened[index] = !this.menuOpened[index];
  }

  get activeReportsLength() {
    return this.activeReports.length;
  }

  get commonTabsLength() {
    let result = this.activeReportsLength;

    if(this.$store.state.table.settingsTabRoute) {
      result++;
    }

    return result;
  }

  get isManyReports() {
    return this.activeReportsLength > 4;
  }

  get hasCommonTab() {
    return this.activeReports.length || this.$store.state.table.settingsTabRoute;
  }

  isGroupingOpen: boolean = false;
  isOverflowing: boolean = false;
  lastBarWidth: number = 0;
  windowWidth: number = window.innerWidth;

  get showPlainTabs() {
    return this.isManyReports || this.isOverflowing;
  }

  get smToMdWidth() {
    return this.windowWidth > 600 && this.windowWidth <= 1264;
  }

  get forceShowGroupingTabs() {
    return !this.showPlainTabs && this.smToMdWidth && this.hasCommonTab;
  }

  @Watch('isManyReports')
  onisManyReportsChanged(value: boolean) {
    if(!value) {
      this.isGroupingOpen = false;
    }
  }

  @Watch('commonTabsLength')
  onCommonTabsLengthChanged() {
    this.$helpers.afterBrowserRedraw(() => {
      this.recalcTabsWidth(false);
    });
  }

  mounted() {
    this.bus.on('entity-change-name', this.onBusEntityChangeName);

    window.addEventListener('resize', this.onWindowResize);
    this.recalcTabsWidth(false);
  }

  beforeDestroy() {
    this.bus.off('entity-change-name', this.onBusEntityChangeName);
    window.removeEventListener('resize', this.onWindowResize);
  }

  onBusEntityChangeName(payload: any) {
    this.$store.state.table.activeReports.forEach((report: any) => {
      if(report.id === payload.id) {
        this.$store.commit('tableRenameTab', payload);
      }
    });
  }

  onWindowResize() {
    this.windowWidth = window.innerWidth;
    this.recalcTabsWidth();
  }

  recalcTabsWidth(isResize: boolean = true) {
    const tabs: any = this.$refs.tabs;
    const tabsHost: any = this.$refs.tabsHost;
    let isOverflowing: boolean = tabs.isOverflowing;

    const rectTabs: any = tabs.$el.getBoundingClientRect();
    const rectTabsHost: any = tabsHost.getBoundingClientRect();

    this.isOverflowing = rectTabs.width > rectTabsHost.width;
  }

  handleLogoClick() {
    if(this.$vuetify.breakpoint.mdAndUp) {
      this.clickTab(this.defaultHomepage());
    } else {
      this.openMobileMenuOpen();
    }
  }

  openMobileMenuOpen() {
    this.$store.commit('mobileMenuOpen', true);
  }

  handleOpenBookmark(options) {
    this.bus.emit('open-dialog', { name: 'BookmarkAddDialog', data: options })
  }

  handleTabItemMouseDown(event: MouseEvent, tab: any) {
    if(tab.meta && tab.meta.mouseEvents && event.button ===  1) {
      event.preventDefault();
      return false;
    }
  }

  handleTabItemMouseUp(event: MouseEvent, tab: any) {
    if(tab.meta && tab.meta.mouseEvents && event.button ===  1) {
      this.$nextTick(() => {
        this.closeTab(event, tab.meta.tabId);
      });
    }
  }

  handleOpenMobileMenu() {
    // const mobileReportTabs = this.$refs.mobileReportTabs as Vue;
    // const rect = mobileReportTabs.$el.getBoundingClientRect();

    // this.$store.commit('mobileMenuReportTabsTop', rect.bottom + 1);

    this.$store.commit('mobileMenuReportTabsTop', 40);

    const { menuReportTabsOpen } = this.$store.state.mobile;
    this.$helpers.afterBrowserRedraw(() => {
      this.$store.commit('mobileMenuReportTabsOpen', !menuReportTabsOpen);
    });
  }

  closeAllTabs(event: MouseEvent) {
    event.stopPropagation();

    this.activeReports.forEach((item) => {
      this.$store.commit('tableCloseTab', item.tabId);
    });

    this.closeSettingsTab();

    this.$router.push(this.defaultHomepage(), () => {
      this.$nextTick(() => {
        this.bus.emit('reload-report');
      });
    });
  }

  @Watch('$route')
  closeReport(val: any) {
    const reportId = val.query.exitReport;
    if (reportId) {
      this.$store.commit('tableRemoveTab', {
        id: reportId,
        _remove: true
      });
    }
  }
}

